// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".has-error .desc[data-v-59358a94]{opacity:0;transition:all 2s ease}.required[data-v-59358a94]{color:red}", ""]);
// Exports
module.exports = exports;
